import React from "react";
import { Controller, Control } from "react-hook-form";
import { FormGroup, Input, Checkbox } from "@cofano/cck";
import { Language } from "imports/Utils";
import { CargoForm } from "types/index";

const OutOfGauge = ({ control }: {
	control: Control<CargoForm>,
}) => {
	return (
		<React.Fragment>
			<FormGroup label={Language("CARGO_OOG_OVER_HEIGHT")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="overheight"
					control={control}
					render={({ field }) => <Input {...field} addonAfter="cm" />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_OOG_OVER_LENGTH")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="overlength"
					control={control}
					render={({ field }) => <Input {...field} addonAfter="cm" />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_OOG_OVER_LENGTH_BEHIND")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="overlengthBehind"
					control={control}
					render={({ field }) => <Input {...field} addonAfter="cm" />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_OOG_OVER_WIDTH_RIGHT")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="overwidthRight"
					control={control}
					render={({ field }) => <Input {...field} addonAfter="cm" />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_OOG_OVER_WIDTH_LEFT")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="overwidthLeft"
					control={control}
					render={({ field }) => <Input {...field} addonAfter="cm" />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_OOG_DOOR_CLOSED")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="doorOpen"
					control={control}
					render={({ field }) => <Checkbox {...field} value={undefined} checked={field.value} />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_OOG_CHAINS")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="chains"
					control={control}
					render={({ field }) => <Checkbox {...field} value={undefined} checked={field.value} />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_OOG_GENERATOR")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="generator"
					control={control}
					render={({ field }) => <Checkbox {...field} value={undefined} checked={field.value} />} />
			</FormGroup>
		</React.Fragment>
	);
};

export default OutOfGauge;
